
  <div class="container-fluid">
	<div class="row min-hieght-2500px display_block lms-cstm-content">
	  <div class="col-md-3 side-bar-cstm" [style.display]="isDivVisible ? 'block' : 'none'" [hidden]="isSideBarHidden">
		<span >Total Chapters : {{total_chapters}}</span> | 
			<span>Total Topics : {{total_topics}}</span>
		<div class="list-group" id="items"> 
			
		  <div class="modal-cross-wrap">
			<span class="d-flex icons">
				<i class="ft-chevrons-up cursor larger-icon text-white mx-1" (click)="toggleExpandAll(true)"   ngbTooltip="expand view" placement="right"></i>
				<i class="ft-chevrons-down larger-icon text-white mx-1" (click)="toggleExpandAll(false)"  ngbTooltip="collapse view" placement="right"></i>

			</span>
			<i class="ft-x cursor-pointer" (click)="toggleVisibility()"></i>
		</div>
		<div>
			<ng-select [items]="flattenedItems" bindLabel="name" placeholder="Select" (search)="onSearch($event.term)"
				[virtualScroll]="true" (keydown.enter)="searchAndGetAppsInACourse()">
				<ng-template ng-option-tmp let-item="item">
					<div class="d-flex flex-column p-2 border rounded mb-2" (click)="selectItemfromSearchList(item)">
						<div class="d-flex justify-content-between align-items-center">
							<ng-container *ngIf="item.category === 'Section'; else otherCategories">
								<strong class="text-section flex-grow-1 text-truncate">
									{{ item.name }}
								</strong>
							</ng-container>
							<ng-template #otherCategories>
								<div class="flex-grow-1 text-truncate" [ngClass]="{
		                  'text-chapter': item.category === 'Chapter',
		                  'text-topic': item.category === 'Topic'
		                }">
									{{ item.name }}
								</div>
							</ng-template>
							<small class="text-muted text-truncate" *ngIf="item.category">{{ item.category }}</small>
						</div>
		
					</div>
				</ng-template>
		
			</ng-select>
		
		</div>
		  <ul>
			<li class="cursor" *ngFor="let section of sections; let sectionIndex = index">
			  <div  class="list-group-item section-list" [ngClass]="{'active-section': activeSectionId==section?._id}">
				<div (click)="activeBreadcrumb(section?.name, section?._id)" data-toggle="collapse"
				  [attr.data-target]="'#sectionCollapse' + sectionIndex" class="sidee-nav-section">
				  <div *ngIf="section?.isEditing">
					<input [(ngModel)]="section.name" (keydown.enter)="editItem($event, 'section', sectionIndex)">
				  </div>
				  <div class="list-title" *ngIf="!section?.isEditing">
					{{ section?.name }}
					<i class="ft-chevron-down"></i>
					<!-- ft-chevron-up -->
					<!-- <div style="display: flex">
					  <i *ngIf="section.chapters?.length" class="fa fa-chevron-down cursor"
						[ngbCollapse]="'#sectionCollapse' + sectionIndex"></i>
					</div> -->
				  </div>
				</div>
				<ul [id]="'sectionCollapse' + sectionIndex" class="collapse"
				[ngbCollapse]="!(expandAll || section?.collapsed)"
                [class.show]="expandAll || sectionIndex === 0">
				  <li class="cursor" *ngFor="let chapter of section?.chapters; let chapterIndex = index">
					<div class="list-group-item chapter-list"
					  [ngClass]="{'active-chapter': activeChapterId==chapter?._id}">
					  <div (click)="activeBreadcrumb(section?.name, section?._id, chapter?.name, chapter?._id)"
						data-toggle="collapse" class="inner-chapter" 
						[attr.data-target]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex">
						<div class="list-title" *ngIf="!chapter?.isEditing">
						  {{ chapter?.name }}
						  <i class="ft-chevron-down"></i>
						</div>
					  </div>
					  <ul [id]="'chapterCollapse' + sectionIndex + '-' + chapterIndex" class="collapse"
					  [ngbCollapse]="!(expandAll || chapter?.collapsed)"
					  [class.show]="expandAll || (sectionIndex === 0 && chapterIndex === 0)">
						<li class="cursor"
						  (click)="getAppsByTopic(topic?._id, chapter.topics); activeBreadcrumb(section?.name, section._id, chapter?.name, chapter._id, topic?.name, topic._id)"
						  *ngFor="let topic of chapter.topics; let topicIndex = index" >
						  <div class="list-group-item topic-list" [ngClass]="{'active-topic': activeTopicId==topic?._id}">
							<div class="list-title" *ngIf="!topic?.isEditing">
							  {{ topic.name }}
								<span class="d-flex"><i class="ft-check text-info" *ngIf="!isTeacherPendingTopic(topic?._id)"></i><i *ngIf="!isStudentPendingTopic(topic?._id)" class="ft-check text-success"></i></span>
							</div>
						  </div>
						</li>
					  </ul>
					</div>
				  </li>
				</ul>
			  </div>
			</li>
		  </ul>
		</div>
  
	  </div>
   
	  <!-- {'col-12': isSideBarHidden} -->
  
	  <div [ngClass]="{'col-md-9': isDivVisible, 'col-md-12': !isDivVisible ,'video-container': true}">
		
		<!-- <div id="bc_wrapper">
		  <h3>{{ courseData?.title }}</h3>
		  <span class="section_bc text-capitalize" *ngIf="activeSectionName">&gt;&gt; {{ activeSectionName }}</span>
		  <span class="chapter_bc text-capitalize" *ngIf="activeChapterName">&gt;&gt; {{ activeChapterName }}</span>
		  <span class="topic_bc blue_c text-capitalize" *ngIf="activeTopicName">&gt;&gt; {{ activeTopicName }}</span>
		</div> -->
		<!-- <span>
			<div class="d-flex justify-content-between align-items-center">
				<button (click)="goToPreviousTopic()" [disabled]="currentTopicIndex === 0" class="btn btn-secondary">Previous</button>
				<button (click)="goToNextTopic()"  class="btn btn-primary">Next</button>
			  </div>
		 </span> -->
		<!-- <app-lms-content [hidden]="isLmsContent"  [topics]="selectedTopics" (refreshData)="getAppsByTopic(topicId,selectedTopics)"
		  [appsByTopic]="appsByTopic" [isReadMode]="isReadMode" [topicId]="topicId" 
		  [courseId]="courseId" [activeCourseName]="activeCourseName" [activeSectionName]="activeSectionName" [activeChapterName]="activeChapterName" [activeTopicName]="activeTopicName" ></app-lms-content> -->
		  <app-lms-content
		  [hidden]="isLmsContent"
		  [topics]="selectedTopics"
		  [appsByTopic]="appsByTopic"
		  [isReadMode]="isReadMode"
		  [topicId]="topicId"
		  [courseId]="courseId"
		  [activeCourseName]="activeCourseName"
		  [activeSectionName]="activeSectionName"
		  [activeChapterName]="activeChapterName"
		  [activeTopicName]="activeTopicName"
		  [currentTopicIndex]="currentTopicIndex"
		  (previousTopic)="goToPreviousTopic()"
		  (nextTopic)="goToNextTopic()"
		  (refreshData)="getAppsByTopic(topicId, selectedTopics)">
		</app-lms-content>
		</div>
  
	  <div class="lms-btn-cstm-wrap">
		<button *ngIf="!isDivVisible" (click)="toggleVisibility()" class="btn btn-primary lms-btnn">
			<span>Course Content</span>
			<i class="fa-solid fa-arrow-right"></i>
		</button>
		
	  </div>
	</div>
  </div>
  
  <!---------- Teacher for Time Update  Modal  ---------------->
  <div>
	<ng-template #myModal let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">Teach Time</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<form>
		  <div class="form-group">
			<label>Teaching Time</label>
			<input type="datetime-local" class="form-control" [(ngModel)]="teaching_time"
			  [ngModelOptions]="{standalone: true}">
		  </div>
		</form>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
	  </div>
	</ng-template>
  </div>
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>